/**
 * Sheet defaults. English off — both of them — matches the wall sheet the
 * workbook produces; turning either on is a deliberate choice with a cost,
 * which is why the Settings menu states that cost rather than presenting them
 * as free toggles.
 */
export const DEFAULTS = {
  showSubtitle: false,
  showCivilDate: false,
}

/**
 * The year of Shabbosim, offered where every other sheet is chosen.
 *
 * It is not an occasion the engine knows — it is the whole year of them — so
 * the key is this screen's own and never reaches `occasion.resolve`. It belongs
 * in this field because the question the field asks is which sheet of times you
 * want, and "every Shabbos of the year" is one of the answers to it.
 */
export const ALL_SHABBOSIM = 'all_shabbosim'

/** The sheet built from columns somebody picked rather than from a shipped set. */
export const CUSTOM = 'custom'

/**
 * How the columns are grouped, and in what order they print.
 *
 * By DAY first, in the order a week runs — what the week is, then the night it
 * comes in, then Shabbos itself. That is what makes a bare name enough: `עלות
 * השחר` under `Erev Shabbos` says which alos it is, where `Erev alos` is not
 * what anybody calls it.
 *
 * Then by KIND within the day: what the shul does, and after it what the sun
 * does. The catalog is seventeen zmanim per day and the lines are the reason
 * somebody opened the picker, so a list that opened on the zmanim would bury
 * them.
 *
 * The same order is the print order, so a column lands on the day it belongs to
 * rather than where somebody happened to click.
 */
export const COLUMN_GROUPS = [
  { role: null, zmanim: false, label: 'The week' },
  { role: 'erev', zmanim: false, label: 'Erev Shabbos' },
  { role: 'erev', zmanim: true, label: 'Erev Shabbos · zmanim' },
  { role: 'day', zmanim: false, label: 'Shabbos' },
  { role: 'day', zmanim: true, label: 'Shabbos · zmanim' },
] as const

/**
 * A custom set's orientation, since nobody chose one.
 *
 * Four columns is where the shipped sets divide — candle lighting is three and
 * portrait, the full Shabbosim nine and landscape — so the same line answers
 * for a set built by hand. It is a starting page, not a cap: the sheet's own
 * paginator continues a set too wide for one band sideways either way.
 */
export const orientationFor = (columns: string[]) =>
  columns.length > 4 ? ('landscape' as const) : ('portrait' as const)
